<template>
    <v-chip
        :close="close"
        small
        label
        class="pl-1 font-weight-medium"
        color="n1"
        text-color="neutral_n500"
        @click="onClick"
        @click:close="onClickClose"
    >
        <v-chip
            x-small
            :text-color="fileName | file_color"
            color="white"
            label
            class="text-uppercase caption mr-2 font-weight-medium file-extension"
            style="border-radius: 4px!important"
        >
            {{ fileName | file_extension }}
        </v-chip>
        <span style="max-width: 152px" class="text-truncate">{{ fileName | file_name }}</span>
    </v-chip>
</template>

<script>
export default {
    name: "FileChip",
    props: {
        fileName: {
            type: String,
            required: true
        },
        close: {
            type: Boolean,
            default: false
        }
    },
    setup(props, context) {
        const onClickClose = () => {
            context.emit("click:close");
        };
        const onClick = () => {
            context.emit("click:action");
        };
        return {
            onClickClose,
            onClick
        };
    }
};
</script>